import { useContext, useEffect, useMemo, useState } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { Col } from 'react-bootstrap';

const RouteMap = () => {
  const { settings, trackingDetails } = useContext(AppContext);
  const [mapWidth, setMapWidth] = useState(450);

  console.log('Rendering RouteMap with Mailbox');

  useEffect(() => {
    const updateMapWidth = () => {
      const width = window.innerWidth;
      let size;

      if (width >= 1200) {
        size = 1200;
      } else if (width >= 768) {
        size = 750;
      } else {
        size = 450;
      }

      setMapWidth(size);
    };

    updateMapWidth();
    window.addEventListener('resize', updateMapWidth);
    return () => window.removeEventListener('resize', updateMapWidth);
  }, []);

  const brandSettings = useMemo(
    () => ({
      riderIcon: encodeURIComponent(settings?.brand?.riderIcon || ''),
      userIcon: encodeURIComponent(settings?.brand?.userIcon || '')
    }),
    [settings?.brand?.riderIcon, settings?.brand?.userIcon]
  );

  const recipientPosition = useMemo(
    () => ({
      latitude: trackingDetails?.streetAddress?.latitude,
      longitude: trackingDetails?.streetAddress?.longitude
    }),
    [trackingDetails?.streetAddress?.latitude, trackingDetails?.streetAddress?.longitude]
  );

  const riderPosition = useMemo(
    () => ({
      latitude: trackingDetails?.lastKnownLatitude || null,
      longitude: trackingDetails?.lastKnownLongitude || null
    }),
    [trackingDetails?.lastKnownLatitude, trackingDetails?.lastKnownLongitude]
  );

  const mapUrl = useMemo(() => {
    const riderIconParam =
      riderPosition?.longitude && riderPosition?.latitude ? `,url-${brandSettings.riderIcon}(${riderPosition.longitude},${riderPosition.latitude})` : '';

    return `${process.env.REACT_APP_STATIC_MAP_URL}/url-${brandSettings.userIcon}(${recipientPosition.longitude},${recipientPosition.latitude})${riderIconParam}/auto/${mapWidth}x450?access_token=${process.env.REACT_APP_STATIC_MAP_TOKEN}`;
  }, [
    riderPosition?.latitude,
    riderPosition?.longitude,
    brandSettings.riderIcon,
    brandSettings.userIcon,
    recipientPosition.latitude,
    recipientPosition.longitude,
    mapWidth
  ]);

  return (
    <Col className="map_wrapper">
      <img src={mapUrl} alt="MailBox Map" className="map_container" />
    </Col>
  );
};

export default RouteMap;
